import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { stylesConstants } from '../../styles/stylesConstants';

export default makeStyles((theme: Theme) => ({
  background: {
    backgroundColor: theme.palette.primary.main,
    width: '100vw',
    height: '100vh',
    display: 'flex',
  },
  emailVerificationForm: {
    margin: 'auto',
    boxShadow: theme.shadows[1],
    background: theme.palette.background.default,
    padding: `${theme.spacing(3)}px ${theme.spacing(4)}px ${theme.spacing(2)}px`,
    borderRadius: theme.spacing(1),
    flexDirection: 'column',
    display: 'flex',
    maxWidth: stylesConstants.emailVerificationBoxWidth,
    flex: 0.8,
  },
  subtitle: {
    marginTop: theme.spacing(2),

    textAlign: 'center',
  },
  inputContainer: {
    marginBottom: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
  },
}));
